import React from "react";
import { Tooltip } from "@mui/material";
import { Palette } from "../AppConfig";
import ViewInArIcon from "@mui/icons-material/ViewInAr";

const styles = {
    lysaght: { color: Palette.Lysaght.DarkBlue },
};

export default function ARViewCountChip(props) {
    const { job } = props;
    const views = Array.isArray(job?.AnonymousARViews) ? job.AnonymousARViews : [];
    const viewCount = views.length;

    if (viewCount === 0) return null;

    const createTable = (views) => (
        <table style={{ borderCollapse: "collapse" }}>
            <thead>
                <tr>
                    <th style={{ padding: "4px", borderBottom: "1px solid #ccc" }}>Timestamp</th>
                    <th style={{ padding: "4px", borderBottom: "1px solid #ccc" }}>Device</th>
                    <th style={{ padding: "4px", borderBottom: "1px solid #ccc" }}>OS</th>
                    <th style={{ padding: "4px", borderBottom: "1px solid #ccc" }}>Browser</th>
                    <th style={{ padding: "4px", borderBottom: "1px solid #ccc" }}>Approx. Location</th>
                </tr>
            </thead>
            <tbody>
                {views.map((view) => (
                    <tr key={view.id}>
                        <td style={{ padding: "4px" }}>{view?.time || "Unknown"}</td>
                        <td style={{ padding: "4px" }}>{view?.device || "Unknown"}</td>
                        <td style={{ padding: "4px" }}>{view?.os || "Unknown"}</td>
                        <td style={{ padding: "4px" }}>{view?.browser || "Unknown"}</td>
                        {!view?.city || !view?.country || view?.city === "Unknown" || view?.country === "Unknown" ? (
                            <td style={{ padding: "4px" }}>Unknown</td>
                        ) : (
                            <td style={{ padding: "4px" }}>
                                {view.city}, {view.country}
                            </td>
                        )}
                    </tr>
                ))}
            </tbody>
        </table>
    );

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                color: window.LYSAGHT ? "#3B64AB" : "#01507e",
                fontWeight: "bold",
            }}
            onClick={(e) => e.stopPropagation()}
        >
            <span style={{ marginRight: "5px", paddingBottom: "4px" }}>{viewCount}</span>
            <Tooltip title={<div style={{ overflowX: "auto" }}>{createTable(views)}</div>} arrow placement="top">
                <span role="button" style={{ cursor: "pointer" }}>
                    <ViewInArIcon style={{ paddingRight: 10 }} />
                </span>
            </Tooltip>
        </div>
    );
}
